// extracted by mini-css-extract-plugin
module.exports = {"preTitle":"homeServiceCard_preTitle__3HZ1B","text":"homeServiceCard_text__V8TYb","img":"homeServiceCard_img__2_87Q","link":"homeServiceCard_link__abg_v","imgContainerdesktop":"homeServiceCard_imgContainerdesktop__1Resw","container":"homeServiceCard_container__3b7Mu","btn":"homeServiceCard_btn__1a6L_","mobile":"homeServiceCard_mobile__1feoB"};
    if(module.hot) {
      // 1747211680165
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  